const baseURL = "/v1/UnidadeTematica";

const service = {
  methods: {
    $buscarUnidadesTematicas(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarUnidadesTematicas({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarUnidadeTematica(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarUnidadeTematica(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarUnidadeTematica(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
